import { Concept } from '@fusion-advantage/formlib'
import L1Markdown from '../l1/L1Markdown'

interface L3MarkdownProps {
	concept?: Concept
	content?: string
}

const L3Markdown = ({concept, content}: L3MarkdownProps) => {
	return <L1Markdown content={content ?? concept?.title ?? ''} />
}

export default L3Markdown
